var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.labelClass},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.icon),expression:"icon"}],class:_vm.icon,staticStyle:{"margin-right":"10px"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }